module.exports = __webpack_public_path__ + "static/img/rank_28.4fb1d62.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_28.png
// module id = K/mw
// module chunks = 0